<template>
  <div id="app" class="text-gray-900">
    <!-- This example requires Tailwind CSS v2.0+ -->
    <nav class="bg-white border-b border-grey-100 font-bold">
      <div class="max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
        <div class="relative flex items-center justify-between h-16">
          <div class="absolute inset-y-0 left-0 flex items-center sm:hidden">
            <!-- Mobile menu button-->
            <p
              class="inline-flex items-center justify-center p-2 rounded-md hover:bg-gray-200 cursor-pointer"
              aria-expanded="false"
              @click="menu_visible = !menu_visible"
            >
              <span class="sr-only">Open main menu</span>
              <!-- Icon when menu is closed. -->
              <!--
            Heroicon name: menu

            Menu open: "hidden", Menu closed: "block"
          -->
              <svg
                class="block h-6 w-6"
                v-bind:class="{ hidden: menu_visible }"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
              <!-- Icon when menu is open. -->
              <!--
            Heroicon name: x

            Menu open: "block", Menu closed: "hidden"
          -->
              <svg
                class="h-6 w-6"
                v-bind:class="{ hidden: !menu_visible }"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
                aria-hidden="true"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </p>
          </div>
          <div
            class="h-full flex-1 flex items-center justify-center sm:items-stretch sm:justify-start"
          >
            <div class="flex-shrink-0 flex items-center">
              <div class="block lg:hidden h-10 w-auto">
                <!-- class="flex flex-col justify-center mr-5 sm:mx-auto"> -->
                <router-link class="text-3xl text-blue-800 font-bold" to="/"
                  >CSSNLP</router-link
                >
              </div>
              <div class="hidden lg:block w-auto px-4 h-10">
                <!-- class="block lg:hidden h-8 w-auto"> -->
                <!-- class="flex flex-col justify-center mr-5 sm:mx-auto"> -->
                <router-link class="text-3xl text-blue-800 font-bold" to="/"
                  >CSSNLP</router-link
                >
              </div>
            </div>
            <div class="h-full hidden sm:block sm:ml-6 pt-2">
              <div class="flex space-x-4 h-full">
                <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
                <div
                  class="border-b-2 border-transparent h-full flex-col px-4 flex justify-center"
                  v-bind:class="{
                    'border-blue-700': this.$router.currentRoute.path == '/',
                    'text-blue-700': this.$router.currentRoute.path == '/',
                  }"
                >
                  <router-link
                    class="hover:text-blue-700 trainsition-all duration-100"
                    to="/"
                    >首页</router-link
                  >
                </div>
                <div
                  class="border-b-2 border-transparent h-full flex-col px-4 flex justify-center"
                  v-bind:class="{
                    'border-blue-700': current_page.includes('program'),
                    'text-blue-700': current_page.includes('program'),
                  }"
                >
                  <router-link
                    class="hover:text-blue-700 trainsition-all duration-100"
                    to="/program"
                    >日程</router-link
                  >
                </div>
                <div
                  class="border-b-2 border-transparent h-full flex-col px-4 flex justify-center"
                  v-bind:class="{
                    'border-blue-700': current_page.includes('forum'),
                    'text-blue-700': current_page.includes('forum'),
                  }"
                >
                  <router-link
                    class="hover:text-blue-700 trainsition-all duration-100"
                    to="/forum"
                    >论坛</router-link
                  >
                </div>
                <div
                  class="border-b-2 border-transparent h-full flex-col px-4 flex justify-center"
                  v-bind:class="{
                    'border-blue-700': current_page.includes('committee'),
                    'text-blue-700': current_page.includes('committee'),
                  }"
                >
                  <router-link
                    class="hover:text-blue-700 trainsition-all duration-100"
                    to="/committee"
                    >组委会</router-link
                  >
                </div>
                <div
                  class="border-b-2 border-transparent h-full flex-col px-4 flex justify-center"
                  v-bind:class="{
                    'border-blue-700': current_page.includes('contact'),
                    'text-blue-700': current_page.includes('contact'),
                  }"
                >
                  <router-link
                    class="hover:text-blue-700 trainsition-all duration-100"
                    to="/contact"
                    >联系我们</router-link
                  >
                </div>
              </div>
            </div>
          </div>
          <div
            class="absolute inset-y-0 right-0 flex items-center pr-2 sm:static sm:inset-auto sm:ml-6 sm:pr-0"
          ></div>
        </div>
      </div>

      <!--
    Mobile menu, toggle classes based on menu state.

    Menu open: "block", Menu closed: "hidden"
  -->
      <div
        v-bind:class="{ hidden: !menu_visible }"
        class="sm:hidden border-t border-gray"
      >
        <div
          class="px-12 py-2 text-center"
          @click="menu_visible = !menu_visible"
        >
          <!-- Current: "bg-gray-900 text-white", Default: "text-gray-300 hover:bg-gray-700 hover:text-white" -->
          <router-link
            class="py-2 hover:bg-gray-200 rounded block hover:text-blue-700 trainsition-all duration-100 w-full"
            v-bind:class="{
              'text-blue-700': this.$router.currentRoute.path == '/',
            }"
            to="/"
            >首页</router-link
          >
          <router-link
            class="py-2 hover:bg-gray-200 rounded block hover:text-blue-700 trainsition-all duration-100 w-full"
            v-bind:class="{
              'text-blue-700': this.$router.currentRoute.path == '/program',
            }"
            to="/program"
            >日程</router-link
          >
          <router-link
            class="py-2 hover:bg-gray-200 rounded block hover:text-blue-700 trainsition-all duration-100 w-full"
            v-bind:class="{
              'text-blue-700': this.$router.currentRoute.path == '/forum',
            }"
            to="/forum"
            >论坛</router-link
          >
          <router-link
            class="py-2 hover:bg-gray-200 rounded block hover:text-blue-700 trainsition-all duration-100 w-full"
            v-bind:class="{
              'text-blue-700': this.$router.currentRoute.path == '/committee',
            }"
            to="/committee"
            >组委会</router-link
          >
          <router-link
            class="py-2 hover:bg-gray-200 rounded block hover:text-blue-700 trainsition-all duration-100 w-full"
            v-bind:class="{
              'text-blue-700': this.$router.currentRoute.path == '/contact',
            }"
            to="/contact"
            >联系我们</router-link
          >
        </div>
      </div>
    </nav>

    <router-view class="min-h-screen" />
    <div class="text-center py-16 bg-blue-900 text-white mt-10 text-sm">
      <div class="flex flex-col space-y-1">
        <p>
          <span>主办单位：</span>
          <span> 中文信息学会青年工作委员会 </span>
        </p>
        <p>
          <span>社区支持：</span>
          <span> 智源社区 </span>
        </p>
      </div>
      <p class="mt-10">© CSSNLP All rights reserved</p>
    </div>
  </div>
</template>

<script>
export default {
  metaInfo: {
    title: 'CSSNLP 2020',
    titleTemplate: '%s | CSSNLP 2020',
    meta: [
      {
        name: 'description',
        content:
          '中国自然语言处理学生研讨会（The China Student Symposium on Natural Language Processing, CSSNLP 2020）将于2020年12月26日-12月27日在北京首次举办。会议主办单位为中国中文信息学会（CIPS）青年工作委员会，会议地点在北京智源人工智能研究院。本次会议为第一届中国自然语言处理学生研讨会，包含特邀报告、前沿主题讲习班、博士生论坛、COLING 论文和 EMNLP 论文报告五个环节，主要目的是为自然语言处理研究领域内的中国青年学者提供一个学术交流平台。同时鼓励更多的青年学者关注自然语言处理前沿研究，展示最新科研成果，促进国内青年学者的思想交流和学术合作，进而推动自然语言处理在中国的发展。本次 CSSNLP 2020 将线下线上同时举行，线下可通过注册进行参会，线上通过视频直播对外开放。',
      },
    ],
  },
  data() {
    return {
      menu_visible: false,
    };
  },
  computed: {
    current_page: function () {
      return this.$route.path;
    },
  },
};
</script>

<style>
#app {
  /* font-family: Avenir, Helvetica, Arial, sans-serif; */
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
</style>
